const Types = {
  GET_PROMPTS: '@prompt/GET_PROMPTS',
  GET_PROMPTS_SUCCESS: '@prompt/GET_PROMPTS_SUCCESS',
};

export default Types;
